const TiposUsuario = {
  suscriptor: 'Suscriptor',
  secundario: 'Secundario',
}

export default TiposUsuario;
